module.exports = __webpack_public_path__ + "img/revenues-types.3c764f89.svg";